import { NewNames as NewNamesForm } from "@bgea-js/form-templates";
import donationHeaderSpanishBiblicalGuide from "../../../../src/content/spanish-biblical-guide-elections/donationHeader";
import * as React from 'react';
export default {
  NewNamesForm,
  donationHeaderSpanishBiblicalGuide,
  React
};